import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Brain, Grape, Zap, Droplet } from "lucide-react";

const ingredients = [
  {
    icon: Brain,
    name: "Lion's Mane",
    description: "Supports focus, memory & cognitive performance.",
  },
  {
    icon: Grape,
    name: "Schisandra Berries",
    description: "Helps the body adapt to stress & fatigue.",
  },
  {
    icon: Zap,
    name: "Natural Caffeine",
    description: "Smooth, sustained energy. No crash.",
  },
  {
    icon: Droplet,
    name: "Essential Vitamins",
    description: "B6, B12, Biotin for daily support.",
  },
];

const IngredientsSection = () => {
  return (
    <section className="py-20 sm:py-28">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <h2 className="section-heading">
            Real Ingredients.
            <span className="accent">Real Benefits.</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {ingredients.map((ing) => (
            <div key={ing.name} className="cosmic-card-v2 flex flex-col items-center text-center p-6">
              <div className="relative mb-5 can-halo">
                <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-[hsl(var(--cosmic-mid))] border border-[hsl(var(--magenta)/0.4)] flex items-center justify-center">
                  <ing.icon className="w-10 h-10 text-[hsl(var(--magenta-glow))]" strokeWidth={1.5} />
                </div>
              </div>
              <h3 className="font-display uppercase tracking-[0.1em] text-[hsl(var(--magenta-glow))] text-base sm:text-lg mb-2">
                {ing.name}
              </h3>
              <p className="text-sm text-white/70 leading-relaxed">{ing.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Button asChild className="btn-secondary">
            <Link to="/ingredients">Explore Ingredients</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default IngredientsSection;
